import { createReducer } from '@reduxjs/toolkit';
import { Region, } from '@innovyze/stylovyze/lib/types/regionPicker.types';
import { getUserRegions, getUserRegionsRejected, getUserRegionsResolved, } from '@innovyze/stylovyze/lib/actions/regionPicker.actions';
import { STATUS_ENUM } from '@innovyze/stylovyze/lib/types/reducers.types';
export const initialState = {
    initialized: STATUS_ENUM.IDLE,
    regions: [],
};
const reducer = {
    [getUserRegions.toString()]: state => ({
        ...state,
        initialized: STATUS_ENUM.PENDING,
    }),
    [getUserRegionsResolved.toString()]: (state, action) => ({
        ...state,
        initialized: STATUS_ENUM.SUCCESS,
        regions: action.payload,
    }),
    [getUserRegionsRejected.toString()]: state => ({
        ...state,
        initialized: STATUS_ENUM.ERROR,
        regions: [Region.US],
    }),
};
export default createReducer(initialState, reducer);
